import { ApplicationState, WithServiceId } from '@mews-commander/types';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { getRestriction } from '@mews-commander/legacy-entities/src/ducks/restrictions';
import { getService } from '@mews-commander/legacy-entities/src/ducks/services';
import { canCurrentProfileManageRestrictions } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { checkServicePrivilege } from '@mews-commander/legacy-entities/src/selectors/session/privilegeChecks';

export const checkRestrictionDetailPrivilege = (
    state: ApplicationState,
    { restrictionId, serviceId }: WithServiceId & { restrictionId: string }
) => {
    const restriction = getRestriction(state, { id: restrictionId, serviceId });
    // @ts-expect-error $TSFixMeError: Property 'enterpriseId' does not exist on type 'unknown'.
    const { enterpriseId, isActive } = getService(state, { id: serviceId });

    const isCurrentUserPrivileged = canCurrentProfileManageRestrictions(state);
    const isCorrectEnterpriseId = enterpriseId === getCurrentEnterpriseId();

    return restriction !== undefined && isCorrectEnterpriseId && isActive && isCurrentUserPrivileged;
};

export const checkRestrictionCreatePrivilege = (state: ApplicationState, { serviceId }: WithServiceId) =>
    checkServicePrivilege(state, { serviceId }) !== undefined && canCurrentProfileManageRestrictions(state);
